import styled from 'styled-components';

export const WhatsappLink = styled.a`
  > img {
    width: 20px;
    height: 20px;
  }
`;